/**
 * Call Status Store
 * Zustand store para gerenciar call status local e de outros usuários
 */

import { create } from 'zustand'
import type { LocalCallStatus, CallStatusState } from '@/types/call-status.types'

// Carregar status local do localStorage
const loadLocalStatus = (): LocalCallStatus => {
  try {
    const stored = localStorage.getItem('call-status')
    if (stored) {
      return JSON.parse(stored)
    }
  } catch {
    // Error handled silently
  }

  return {
    isActive: false,
    startedAt: null,
    lastWarningAt: null
  }
}

// Salvar status local no localStorage
const saveLocalStatus = (status: LocalCallStatus) => {
  try {
    localStorage.setItem('call-status', JSON.stringify(status))
  } catch {
    // Error handled silently
  }
}

export const useCallStatusStore = create<CallStatusState>((set, get) => ({
  localStatus: loadLocalStatus(),

  setLocalStatus: (newStatus) => {
    const updated = { ...get().localStatus, ...newStatus }
    saveLocalStatus(updated)
    set({ localStatus: updated })
  },

  activeCalls: [],

  setActiveCalls: (calls) => set({ activeCalls: calls }),

  addActiveCall: (call) => {
    const existing = get().activeCalls.find(c => c.user_id === call.user_id)
    if (!existing) {
      set({ activeCalls: [...get().activeCalls, call] })
    }
  },

  removeActiveCall: (userId) => {
    set({ activeCalls: get().activeCalls.filter(c => c.user_id !== userId) })
  },

  soundEnabled: true,
  setSoundEnabled: (enabled) => set({ soundEnabled: enabled }),

  isUserInCall: (userId) => {
    return get().activeCalls.some(call => call.user_id === userId)
  },

  clearAll: () => {
    localStorage.removeItem('call-status')
    set({
      localStatus: { isActive: false, startedAt: null, lastWarningAt: null },
      activeCalls: []
    })
  }
}))
